/**
 * Carrousel Amber Gas — une vignette par écran sur mobile, flèches discrètes.
 * Les flèches ne s'affichent que si le contenu déborde réellement (donc jamais
 * sur la grille desktop, où tout tient sur une ligne).
 */
class AgCarousel extends HTMLElement {
  connectedCallback() {
    this.track = this.querySelector('[data-ag-track]');
    if (!this.track) return;

    this.prev = this.querySelector('[data-ag-prev]');
    this.next = this.querySelector('[data-ag-next]');

    this.onScroll = this.onScroll.bind(this);
    this.sync = this.sync.bind(this);

    this.prev?.addEventListener('click', () => this.scrollByItem(-1));
    this.next?.addEventListener('click', () => this.scrollByItem(1));
    this.track.addEventListener('scroll', this.onScroll, { passive: true });

    this.resizeObserver = new ResizeObserver(this.sync);
    this.resizeObserver.observe(this.track);

    this.sync();
  }

  disconnectedCallback() {
    clearTimeout(this.timer);
    this.resizeObserver?.disconnect();
    this.track?.removeEventListener('scroll', this.onScroll);
  }

  get items() {
    return Array.from(this.track.children);
  }

  scrollByItem(direction) {
    const first = this.items[0];
    if (!first) return;
    const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
    this.track.scrollBy({ left: direction * (first.getBoundingClientRect().width + gap), behavior: 'smooth' });
  }

  /** Aligne les flèches sur le centre du visuel, pas sur le centre de la carte. */
  positionArrows() {
    const media = this.items[0]?.querySelector('img, svg, .ag-cover') || this.items[0];
    if (!media) return;
    const center = media.getBoundingClientRect().height / 2;
    if (center > 0) this.style.setProperty('--ag-arrow-top', `${Math.round(center)}px`);
  }

  onScroll() {
    const max = this.track.scrollWidth - this.track.clientWidth;
    const x = this.track.scrollLeft;
    this.prev?.toggleAttribute('disabled', x <= 1);
    this.next?.toggleAttribute('disabled', x >= max - 1);
  }

  measure() {
    const overflows = this.track.scrollWidth - this.track.clientWidth > 1;
    this.toggleAttribute('data-ag-scrollable', overflows);
    this.positionArrows();
    this.onScroll();
  }

  /**
   * Une mesure immédiate, puis une seconde au tick suivant : quand
   * ResizeObserver se déclenche, la nouvelle largeur des vignettes n'est pas
   * encore appliquée. On évite requestAnimationFrame, suspendu tant que
   * l'onglet n'est pas visible — les flèches n'apparaîtraient jamais.
   */
  sync() {
    this.measure();
    clearTimeout(this.timer);
    this.timer = setTimeout(() => this.measure(), 0);
  }
}

if (!customElements.get('ag-carousel')) customElements.define('ag-carousel', AgCarousel);
